var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataGrid',{attrs:{"items":_vm.items,"loading":_vm.loading,"id":"exception-logs","headers":_vm.headers,"title":"Exception Logs"},scopedSlots:_vm._u([{key:"item.timestamp",fn:function(ref){
var timestamp = ref.item.timestamp;
return [_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._v(" "+_vm._s(new Date(timestamp).toLocaleString())+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }